import { GeneralGrantPaperFormData } from '@espoon-voltti/nuora-domain/grants'
import * as O from 'fp-ts/lib/Option'

import { ProjectGrantFormData, GeneralGrantFormData } from '../../../domain'

export const maybeProjectGrantForm = (
  x: ProjectGrantFormData | GeneralGrantFormData
): O.Option<ProjectGrantFormData> =>
  x.type === 'PROJECT_GRANT' || x.type === 'PROJECT_GRANT_PAPER'
    ? O.some(x)
    : O.none

export const maybeGeneralGrantForm = (
  x: ProjectGrantFormData | GeneralGrantFormData | GeneralGrantPaperFormData
): O.Option<GeneralGrantFormData | GeneralGrantPaperFormData> =>
  x.type === 'GENERAL_GRANT' || x.type === 'GENERAL_GRANT_PAPER'
    ? O.some(x)
    : O.none
